import Vue from "vue";
import Box from '@/components/box'
import Btn from '@/components/button'
import Table from '@/components/table'
Vue.component('Box',Box)
Vue.component('Btn',Btn)
Vue.component('Table',Table)